import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { Role } from 'src/app/model/roles';
import { AccessService } from '../../navigation/service/access.service';
import { Roles } from '../../system/accounts/roles/model/roles.model';
import { RoleEntityService } from '../service/role-entity.service';

@Component({
    selector: 'roles-dropdown',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {
    @Input() isMultiple: boolean = true;
    @Output() eventEmitterRole = new EventEmitter<Role[]>();
    @Input('reset') reset: boolean;
    roleSelect = new UntypedFormControl('');
    isLoading: boolean = false;
    roles: Role[] = [];

    constructor(public roleService: RoleEntityService, private accessService: AccessService) {
        accessService.getRoles().subscribe((x: Role[]) => {
            this.roles = x;
        });
        /*this.roleService.loaded$.subscribe((roleLoaded) => {
            this.isLoading = true;
            if (!roleLoaded) {
                this.roleService.getAll().subscribe((roles) => {
                    roles.sort((a, b) => {
                        return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                    });
                    this.roles = roles;
                    this.isLoading = false;
                });
            } else {
                this.roleService.entities$.subscribe((roles) => {
                    roles.sort((a, b) => {
                        return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                    });
                    this.roles = roles;
                    this.isLoading = false;
                });
            }
        });*/
    }

    ngOnInit(): void {}
    ngOnChanges(): void {
        if (this.reset) {
            this.roleSelect.patchValue([]);
            this.eventEmitterRole.emit([]);
        }
    }

    toggleAllSelection(matSelect: MatSelect, toggle: boolean) {
        if (toggle) matSelect.options.forEach((item: MatOption) => item.select());
        else matSelect.options.forEach((item: MatOption) => item.deselect());
    }

    selected(change: MatSelectChange) {
        this.eventEmitterRole.emit(change.value);
    }
}
